import styled from 'styled-components';
import { detectMobile } from 'utils/UiHelper';
const getButtonColor = (props) => {
    let color = '#FFFFFF';
    if (props.active) {
        color = '#333333';
    } else if (props.transparent) {
        color = 'FFFFFF';
    } else if (props.disabled || props.dis) {
        color = '#1C3E60';
    } else if (props.white) {
        color = '#333333';
    } else if (props.oddsYellow) {
        color = '#ebcd32';
    } else if (props.grey) {
        color = '#333333';
    }
    return color;
};
export const OddsButtonWrapper = styled.div`
    display: flex;
    justify-content: ${({ isOnlyOdds }) =>
        isOnlyOdds ? 'center' : 'space-between'};
    padding: ${detectMobile() ? '0 5px' : '0 20px'};
    flex-grow: 1;
    font-size: 12px;
    font-weight: bold;
    align-items: center;
`;

export const OddsText = styled.p`
    color: ${(props) => getButtonColor(props)};
`;
